import {useIntl} from 'react-intl';

const Textarea = ({settings, onChange, ...rest}) => {
  const intl = useIntl();
  const {
    name,
    label,
    placeholder,
    state,
    wrapperClasses = '',
    defaultValue,
    required = false,
    disabled = false,
  } = settings || {};

  if (!name) {
    return '';
  }

  const renderLabel = () => {
    if (!label) {
      return '';
    }

    return (
      <label className={`${required ? ' form-required' : ''}`} htmlFor={name}>{label}</label>
    );
  };

  return (
    <div className={wrapperClasses}>
      {renderLabel()}
      <div>
        <textarea
          className={`form-textarea ${required ? 'required' : ''}`}
          name={name}
          onChange={onChange}
          placeholder={placeholder ? intl.formatMessage({id: placeholder}) : ''}
          value={state && state.hasOwnProperty(name) ? state[name] : ''}
          defaultValue={defaultValue}
          required={required}
          disabled={disabled}
          {...rest}
        ></textarea>
      </div>
    </div>
  )
};

export default Textarea;
